import React from "react";
import {
  Field,
  Label,
  LabelText,
  LabelIcon,
  Required,
  Input,
  Salary,
  SalaryElement,
  Divider,
  Error,
} from "../styles/form-styles";

const PermanentActiveContent = (props) => {
  const {
    salaryType,
    salaryMin,
    salaryMax,
    handleTextInput,
    errors,
    currency,
  } = props;
  let activeContent;

  switch (salaryType) {
    case "range":
      activeContent = (
        <Salary>
          <SalaryElement>
            <Label htmlFor="salary-min" salary>
              <LabelText>
                Salary in {currency.symbol} from
                <Required>*</Required>
              </LabelText>
              <LabelIcon />
            </Label>
            <Input
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              type="number"
              name="salaryMin"
              id="salary-min"
              value={salaryMin}
              onChange={(e) => handleTextInput(e)}
            />
          </SalaryElement>
          {errors.salaryMin && <Error salaryMin>{errors.salaryMin}</Error>}
          <Divider>to</Divider>
          <SalaryElement>
            <Label htmlFor="salary-max" salary>
              <LabelText />
            </Label>
            <Input
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              type="number"
              name="salaryMax"
              id="salary-max"
              value={salaryMax}
              onChange={(e) => handleTextInput(e)}
            />
          </SalaryElement>
          {errors.salary_max && <Error salaryMax>{errors.salary_max}</Error>}
        </Salary>
      );
      break;
    default:
      activeContent = (
        <Field>
          <Label htmlFor="salary-min" salary>
            <LabelText>
              Salary in {currency.symbol} <Required>*</Required>
            </LabelText>
          </Label>
          <Input
            onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
            type="number"
            salary
            name="salaryMin"
            id="salary-min"
            value={salaryMin}
            onChange={(e) => handleTextInput(e)}
          />
          {errors.salaryMin && (
            <Error salaryMinSingle>{errors.salaryMin}</Error>
          )}
        </Field>
      );
  }
  return activeContent;
};

export default PermanentActiveContent;
